// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__wyghR","socialLinks":"Footer_socialLinks__19JKX","madeBy":"Footer_madeBy__3cL8P","copyright":"Footer_copyright__1AwIW"};